import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import config from "../config";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../helpers/authConfig";
import { msalInstance } from "../containers/App";
import jwt_decode from "jwt-decode";

// let msalInstance;

/*istanbul ignore next */
fetch("/appConfig/msalContextpath.json", {
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Accept: "application/json",
  },
})
  .then((res) => res.json())
  .then((data) => {
    localStorage.setItem("appConfig", JSON.stringify(data));
    // msalInstance = new PublicClientApplication(msalConfig);
  })
  .catch((error) => {
    console.log(error);
  });

// const msalInstance = new PublicClientApplication(msalConfig);
const httpLink = new HttpLink({ uri: `${config.graphQlendpoint}` });
// let user;
const authMiddleware = new ApolloLink(async (operation, forward) => {
  // const userEmail = localStorage.getItem("user_email");
  // const encryptedEmail = userEmail !== null ? btoa(userEmail) : null;
  let gqlKey = null;
  try {
    const gqlKeyStr = localStorage.getItem("gqlKey");
    gqlKey =
      gqlKeyStr && gqlKeyStr !== "undefined" && gqlKeyStr !== "null"
        ? atob(gqlKeyStr)
        : null;
  } catch (error) {
    console.error("Invalid gqlKey in localStorage", error);
    gqlKey = null;
  }

  let token = await getToken();
  if (token) {
    let access_decode = jwt_decode(token.accessToken);
    const url = window.location.href;

    const match = url.match(/\/customers\/(\d+)\/vessel/);
    let customerId;
    if (match && match[1]) {
      customerId = match[1];
    } else {
      customerId = null;
      console.log("Customer ID not found in the URL.");
    }
    // add the authorization to the headers
    if (customerId !== null) {
      operation.setContext({
        headers: {
          Authorization: "Bearer " + token.accessToken,
          "Authorization-Id": token.idToken,
          "User-Email": btoa(
            access_decode.email
              ? access_decode.email
              : access_decode.unique_name
          ),
          Application: btoa(token.application),
          "Session-Id": token.sessionId,
          "X-Party-Id": customerId,
          ...(gqlKey ? { "x-functions-key": gqlKey } : {})
        },
      });
    } else {
      operation.setContext({
        headers: {
          Authorization: "Bearer " + token.accessToken,
          "Authorization-Id": token.idToken,
          "User-Email": btoa(
            access_decode.email
              ? access_decode.email
              : access_decode.unique_name
          ),
          Application: btoa(token.application),
          "Session-Id": token.sessionId,
          ...(gqlKey ? { "x-functions-key": gqlKey } : {})
        },
      });
    }

    return forward(operation);
  }
});

const logoutLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    let errorCode =
      graphQLErrors[0].extensions && graphQLErrors[0].extensions.code;
    if (errorCode === "UNAUTHENTICATED") {
      console.log("REAUTH");
    }
    if (errorCode == "TOKEN_EXPIRED") {
    }
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const getToken = async () => {
  const account = msalInstance.getAllAccounts()[0];
  if (account === undefined) {
    // Handle the case when no account is found
    const loginRequest = { scopes: ["User.Read"] };

    if (window.self !== window.top) {
      // Inside an iframe
      msalInstance
        .loginPopup(loginRequest)
        .then((response) => {
          console.log("Login successful:", response);
          window.location.reload();
        })
        .catch((e) => {
          console.error("Login pop failed:", e);
          if (
            (typeof e === "object" &&
              e.message &&
              e.message.indexOf("popup_window_error") !== -1) ||
            (typeof e === "string" && e.indexOf("popup_window_error") !== -1)
          ) {
            window.parent.postMessage(
              { type: "popup_window_error", error: e },
              "*"
            );
          }
        });
    } else {
      // Not in an iframe
      msalInstance.loginRedirect({ scopes: ["User.Read"] }).catch((e) => {
        console.log(e);
      });
    }
  } else {
    const accessTokenRequest = {
      scopes: ["User.Read"],
      account: account,
    };
    const token = await msalInstance
      .acquireTokenSilent(accessTokenRequest)
      .then(function (accessTokenResponse) {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        let idToken = accessTokenResponse.idToken;
        let sessionId = accessTokenResponse.account.idTokenClaims.sid;
        let application = accessTokenResponse.account.idTokenClaims.aud;
        let tokens = {
          accessToken,
          idToken,
          sessionId,
          application,
        };
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("application", application);
        return tokens;
        // Call your API with token
      })
      .catch(function (error) {
        //Acquire token silent failure, and send an interactive request
        if (error) {
          msalInstance
            .acquireTokenRedirect(accessTokenRequest)
            .then(function (accessTokenResponse) {
              // Acquire token interactive success
              let accessToken = accessTokenResponse.accessToken;
              let idToken = accessTokenResponse.idToken;
              let sessionId = accessTokenResponse.account.idTokenClaims.sid;
              let application = accessTokenResponse.account.idTokenClaims.aud;
              let tokens = {
                accessToken,
                idToken,
                sessionId,
                application,
              };
              return tokens;
              // Call your API with token
            })
            .catch(function (error) {
              // Acquire token interactive failure
              console.log("reauth failed", error);

              let pathName = window.location.hash;
              localStorage.setItem("redirectPath", pathName);

              if (window.self !== window.top) {
                // Inside an iframe
                msalInstance
                  .loginPopup({
                    scopes: ["User.Read"],
                  })
                  .then((response) => {
                    console.log("Login successful: 7", response);
                  })
                  .catch((e) => {
                    if (
                      (typeof e === "object" &&
                        e.message &&
                        e.message.indexOf("popup_window_error") !== -1) ||
                      (typeof e === "string" &&
                        e.indexOf("popup_window_error") !== -1)
                    ) {
                      window.parent.postMessage(
                        { type: "popup_window_error", error: e },
                        "*"
                      );
                    }
                  });
              } else {
                // Not in an iframe
                msalInstance.loginRedirect({
                  redirectUri: "/",
                });
              }
            });
        }
        console.log(error);
      });

    return token;
  }
};

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authMiddleware, logoutLink, httpLink]),
});
